import { useAppSelector } from "../../hooks/StoreHooks";
import { CompanyManagementUser } from "../../types/companyManagementTypes";

export const useCompanyManagementUsers = (): CompanyManagementUser[] =>
  useAppSelector((state) => state.companyManagement.users);

export const useCompanyManagementUserById = (id: string): CompanyManagementUser | undefined =>
  useAppSelector((state) =>
    state.companyManagement.users.find((user) => user.id === id)
  );
